module.exports = __webpack_public_path__ + "img/portrait-036.ca880e99.jpg";